<template>
  <Layout>
    <template v-slot:top_left>
      <AvatarImage
        :img-url="$page.props.shared.wg.icon_url"
        :label="$page.props.shared.wg.name"
        avatar-size="24px"
        img-size="20px"
      />
      <span class="q-ml-sm text-primary text-bold">{{ $page.props.shared.wg.name }}</span>
    </template>

    <!--
    <template v-slot:header>
      <span class="text-primary text-bold">{{ $page.props.shared.wg.name }}</span>
    </template>
    -->

    <template v-slot:default>
      <template v-if="form_settings.type == 'unselected'">
        <!-- Workspace Type Select -->
        <q-page class="flex flex-center q-mx-auto content-center q-pa-xl centered-container">
          <div class="row wrap justify-center items-start content-start">
            <div class="col-12 q-mb-md text-center">
              <span class="text-h3">{{ i18n.title }}</span>
            </div>

            <div class="col-12 text-center">
              <p>{{ i18n.description }}</p>
            </div>

            <div class="full-width row items-start q-mt-xl q-col-gutter-lg">
              <!-- Individual -->
              <div class="col-xs-12 self-stretch col-md">
                <q-card class="fit">
                  <q-card-section
                    horizontal
                    style="height: 180px"
                    class="justify-center wp_type_illustration_wrapper"
                  >
                    <img
                      class="self-center mx-auto"
                      src="/illustrations/wp_type_casual.svg"
                      height="100"
                    >
                  </q-card-section>

                  <q-card-section
                    horizontal
                    class="text-center"
                  >
                    <!-- label description -->
                    <q-card-section class="col q-my-sm q-pt-none q-px-lg self-center">
                      <p class="q-mb-sm q-mt-none text-subtitle text-bold text-primary text-uppercase">
                        {{ i18n.individual_title }}
                      </p>
                      <span class="text-caption">{{ i18n.individual_description }}</span>
                    </q-card-section>
                  </q-card-section>

                  <q-card-section horizontal>
                    <!-- label description -->
                    <q-card-section class="col q-my-sm q-pt-none q-px-lg self-center text-center">
                      <q-btn
                        class="q-px-xl"
                        color="primary"
                        :label="i18n.button_select"
                        unelevated
                        no-caps
                        @click="form_type_select('individual')"
                      />
                    </q-card-section>
                  </q-card-section>
                </q-card>
              </div>

              <!-- Business -->
              <div class="col-xs-12 self-stretch col-md">
                <q-card class="fit">
                  <q-card-section
                    horizontal
                    style="height: 180px"
                    class="justify-center wp_type_illustration_wrapper"
                  >
                    <img
                      class="self-center mx-auto"
                      src="/illustrations/wp_type_pro.svg"
                      height="100"
                    >
                  </q-card-section>

                  <q-card-section
                    horizontal
                    class="text-center"
                  >
                    <!-- label description -->
                    <q-card-section class="col q-my-sm q-pt-none q-px-lg self-center">
                      <p class="q-mb-sm q-mt-none text-subtitle text-bold text-primary text-uppercase">
                        {{ i18n.business_title }}
                      </p>
                      <span class="text-caption">{{ i18n.business_description }}</span>
                    </q-card-section>
                  </q-card-section>

                  <q-card-section horizontal>
                    <!-- label description -->
                    <q-card-section class="col q-my-sm q-pt-none q-px-lg self-center text-center">
                      <q-btn
                        class="q-px-xl"
                        color="primary"
                        :label="i18n.button_select"
                        unelevated
                        no-caps
                        @click="form_type_select('business')"
                      />
                    </q-card-section>
                  </q-card-section>
                </q-card>
              </div>

              <!-- Accounting Firm -->
              <div
                v-if="false"
                class="col-xs-12 self-stretch col-md"
              >
                <q-card class="fit">
                  <q-card-section
                    horizontal
                    style="height: 180px"
                    class="justify-center wp_type_illustration_wrapper_primary"
                  >
                    <img
                      class="self-center mx-auto"
                      src="/illustrations/wp_type_grands_comptes.svg"
                      height="100"
                    >
                  </q-card-section>

                  <q-card-section
                    horizontal
                    class="text-center"
                  >
                    <!-- label description -->
                    <q-card-section class="col q-my-sm q-pt-none q-px-lg self-center">
                      <p class="q-mb-sm q-mt-none text-subtitle text-bold text-primary text-uppercase">
                        {{ i18n.accounting_firm_title }}
                      </p>
                      <span class="text-caption">{{ i18n.accounting_firm_description }}</span>
                    </q-card-section>
                  </q-card-section>

                  <q-card-section horizontal>
                    <!-- label description -->
                    <q-card-section class="col q-my-sm q-pt-none q-px-lg self-center text-center">
                      <q-btn
                        class="q-px-xl"
                        color="primary"
                        :label="i18n.button_contact_us"
                        unelevated
                        outline
                        no-caps
                      />

                      <p
                        class="q-mb-none q-pt-md text-primary text-caption"
                        style="font-weight: 600"
                      >
                        <a
                          href="https://comptacrypto.com/contact/"
                          target="_blank"
                          class="text-primary"
                        >{{ i18n.accounting_firm_more_info }}</a>
                      </p>
                    </q-card-section>
                  </q-card-section>
                </q-card>
              </div>
            </div>
            <div class="q-mt-lg" />
            <div class="row align-center justify-between q-mt-lg">
              <q-btn
                class="col"
                flat
                outline
                icon="las la-arrow-left"
                :label="i18n.back"
                @click="history_back"
              />
            </div>
          </div>
        </q-page>
      </template>
      <template v-else-if="form_settings.type == 'individual'">
        <!-- Individual Form -->
        <q-page class="row q-mx-auto q-pa-none">
          <div class="col-4 bg-casual bg-casual-img gt-sm" />
          <div class="col-8 col-xs-12 col-md-8">
            <div class="flex items-center justify-center h-full">
              <q-carousel
                v-if="true"
                v-model="step_current"
                animated
                transition-prev="slide-right"
                transition-next="slide-left"
                class="h-auto"
              >
                <!-- Step 1: Individual Name -->
                <q-carousel-slide
                  name="step_individual_name"
                  class="column no-wrap flex-center max-w-lg q-mx-auto"
                >
                  <div class="fit row wrap justify-center items-start content-start">
                    <div class="col-12 q-mb-md">
                      <span class="text-h3">{{ i18n.individual_form_name_title }}</span>
                    </div>
                    <div class="col-12">
                      <p>{{ i18n.individual_form_name_description }}</p>
                    </div>

                    <div class="col-12 q-mt-lg">
                      <q-form @submit.prevent="step_change_next">
                        <div class="col-12">
                          <span class="text-input-label">{{ i18n.individual_form_name_field_name }}</span>
                          <q-input
                            v-model="form.name"
                            :rules="[val => rule_string_len(val, 2, 36)]"
                            class="full-width q-mt-sm"
                            outlined
                            dense
                          />
                        </div>

                        <div class="fit row align-center justify-between q-mt-lg q-pr-xs">
                          <q-btn
                            flat
                            outline
                            icon="las la-arrow-left"
                            :label="i18n.back"
                            @click="form_type_select('unselected')"
                          />
                          <q-btn
                            :label="i18n.next"
                            icon-right="chevron_right"
                            color="primary"
                            no-caps
                            type="submit"
                            unelevated
                          />
                        </div>
                      </q-form>
                    </div>
                  </div>
                </q-carousel-slide>

                <!-- Step 2: Individual Region -->
                <q-carousel-slide
                  name="step_individual_region"
                  class="column no-wrap flex-center max-w-lg q-mx-auto"
                >
                  <div class="fit row wrap justify-center items-start content-start">
                    <div class="col-12 q-mb-md">
                      <span class="text-h3">{{ i18n.individual_form_region_title }}</span>
                    </div>
                    <div class="col-12">
                      <p>{{ i18n.individual_form_region_description }}</p>
                    </div>

                    <div class="col-12 q-mt-lg">
                      <q-form @submit.prevent="">
                        <div class="col-12 q-mb-md">
                          <q-checkbox
                            v-model="form.non_french_resident"
                            :label="i18n.individual_form_region_field_french_resident"
                            dense
                          />
                        </div>

                        <div
                          v-if="!form.non_french_resident"
                          class="col-12"
                        >
                          <span class="text-input-label">{{ i18n.individual_form_region_field_region_label }}</span>
                          <q-select
                            v-model="form.declaration_location_id"
                            :options="locations_fr"
                            option-label="label"
                            class="full-width q-mt-sm"
                            outlined
                            :label="form.declaration_location_id ? undefined : i18n.individual_form_region_field_region_placeholder"
                            dense
                            :rules="[val => !!val || i18n.required]"
                            popup-content-style="height: 300px !important;"
                          >
                            <template v-slot:option="scope">
                              <q-item v-bind="scope.itemProps">
                                <q-item-section side>
                                  <span class="text-bold text-accent">{{ scope.opt.number }}</span>
                                </q-item-section>
                                <q-item-section>
                                  <q-item-label>{{ scope.opt.label }}</q-item-label>
                                  <!-- <q-item-label caption class="text-muted">Zone {{ scope.opt.zone }}</q-item-label> -->
                                </q-item-section>
                              </q-item>
                            </template>
                          </q-select>
                        </div>

                        <div class="fit row align-center justify-end q-mt-md">
                          <div class="col-12 text-center">
                            <q-btn
                              type="submit"
                              color="primary"
                              class="full-width"
                              no-caps
                              :loading="form_submit_state.status == 'loading'"
                              :disabled="form_submit_state.status == 'loading'"
                              :label="i18n.individual_form_submit"
                              unelevated
                              @click="form_submit"
                            />
                          </div>
                          <div class="col-12 text-center q-mt-lg">
                            <q-btn
                              flat
                              outline
                              icon="las la-arrow-left"
                              :label="i18n.back"
                              @click="step_change_previous"
                            />
                          </div>
                        </div>
                      </q-form>
                    </div>
                  </div>
                </q-carousel-slide>

                <!-- Step 3: Individual Submit Status -->
                <q-carousel-slide
                  name="step_individual_submit"
                  class="column no-wrap flex-center max-w-lg q-mx-auto"
                >
                  <div class="row wrap justify-center items-start content-start q-col-gutter-md">
                    <div class="col-12 q-mb-md">
                      <SubmitStatus
                        :i18n="i18n"
                        :status="form_submit_state.status"
                        :error="form_submit_state.error"
                      />
                      <div class="text-center">
                        <template v-if="form_submit_state.status == 'created'" />
                        <template v-else-if="form_submit_state.status == 'loading'" />
                        <template v-else>
                          <q-btn
                            flat
                            outline
                            icon="las la-arrow-left"
                            :label="i18n.back"
                            @click="form_submit_retry"
                          />
                        </template>
                      </div>
                    </div>
                  </div>
                </q-carousel-slide>
              </q-carousel>
            </div>
          </div>
        </q-page>
      </template>
      <template v-else-if="form_settings.type == 'business'">
        <!-- Business Form -->
        <q-page class="row q-mx-auto q-pa-none">
          <div class="col-4 bg-pro bg-pro-img gt-sm" />
          <div class="col-8 col-xs-12 col-md-8">
            <div class="flex items-center justify-center h-full">
              <q-carousel
                v-model="step_current"
                animated
                transition-prev="slide-right"
                transition-next="slide-left"
                class="h-auto"
              >
                <!-- Step 1: Business Country -->
                <q-carousel-slide
                  name="step_business_country"
                  class="column no-wrap flex-center max-w-lg q-mx-auto"
                >
                  <div class="fit row wrap justify-center items-start content-start">
                    <div class="col-12 text-h4 text-center q-mb-xl">
                      {{ i18n.business_form_country_title }}
                    </div>



                    <div class="row full-width q-col-gutter-md justify-center items-center">
                      <!-- 4 cards for country selection -->
                      <div class="col-3">
                        <q-card
                          class="cursor-pointer q-hoverable"
                          @click="form_country_select('fr')"
                        >
                          <span class="q-focus-helper" />
                          <q-card-section class="text-center">
                            <img
                              src="/illustrations/country_flags/fr.svg"
                              :alt="countries.fr.name"
                              class="wp-pro-country-flag"
                            >
                            <div class="text-body2 q-mt-sm">
                              {{ countries.fr.name }}
                            </div>
                          </q-card-section>
                        </q-card>
                      </div>

                      <div class="col-3">
                        <q-card
                          class="cursor-pointer q-hoverable"
                          @click="form_country_select('ch')"
                        >
                          <span class="q-focus-helper" />
                          <q-card-section class="text-center">
                            <img
                              src="/illustrations/country_flags/ch.svg"
                              :alt="countries.ch.name"
                              class="wp-pro-country-flag"
                            >
                            <div class="text-body2 q-mt-sm">
                              {{ countries.ch.name }}
                            </div>
                          </q-card-section>
                        </q-card>
                      </div>

                      <div class="col-3">
                        <q-card
                          class="cursor-pointer q-hoverable"
                          @click="form_country_select('lu')"
                        >
                          <span class="q-focus-helper" />
                          <q-card-section class="text-center">
                            <img
                              src="/illustrations/country_flags/lu.svg"
                              :alt="countries.lu.name"
                              class="wp-pro-country-flag"
                            >
                            <div class="text-body2 q-mt-sm">
                              {{ countries.lu.name }}
                            </div>
                          </q-card-section>
                        </q-card>
                      </div>

                      <div class="col-3">
                        <q-card
                          class="cursor-pointer q-hoverable"
                          @click="form_country_select('other')"
                        >
                          <span class="q-focus-helper" />
                          <q-card-section class="text-center">
                            <img
                              src="/illustrations/country_flags/earth.svg"
                              :alt="countries.other.name"
                              class="wp-pro-country-flag"
                            >
                            <div class="text-body2 q-mt-sm">
                              {{ countries.other.name }}
                            </div>
                          </q-card-section>
                        </q-card>
                      </div>

                      <div class="fit row align-center justify-end q-mt-xl">
                        <div class="col-12 text-center">
                          <q-btn
                            flat
                            outline
                            icon="las la-arrow-left"
                            :label="i18n.back"
                            @click="form_type_select('unselected')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </q-carousel-slide>

                <!-- Step 2: SIREN Search (only for France) -->
                <q-carousel-slide
                  name="step_business_siren"
                  class="column no-wrap flex-center max-w-lg q-mx-auto"
                >
                  <div class="fit row wrap justify-center items-start content-start">
                    <div class="col-12 q-mb-md">
                      <span class="text-h3">{{ i18n.business_form_siren_title }}</span>
                    </div>
                    <div class="col-12">
                      <p>{{ i18n.business_form_siren_description }}</p>
                    </div>

                    <div class="col-12 q-mt-lg">
                      <q-form
                        ref="form_siren_search_form"
                        @submit.prevent
                      >
                        <div class="fit row align-center">
                          <div class="col-12">
                            <span class="text-input-label">SIREN</span>
                            <q-input
                              v-model="form.siren"
                              class="full-width q-mt-sm"
                              outlined
                              dense
                              :placeholder="i18n.business_form_siren_field_placeholder"
                              :rules="[(val) => rule_siren_format(val)]"
                            >
                              <template v-slot:append>
                                <q-btn
                                  type="submit"
                                  round
                                  size="sm"
                                  :loading="form_siren_search_loading"
                                  :disabled="form_siren_search_loading"
                                  icon="search"
                                  color="primary"
                                  unelevated
                                  @click="form_siren_search"
                                />
                              </template>
                            </q-input>
                          </div>
                        </div>
                      </q-form>

                      <q-slide-transition>
                        <div v-if="form_siren_search_error_show">
                          <q-banner
                            class="bg-negative q-mb-lg text-default"
                            inline-actions
                          >
                            <template v-slot:avatar>
                              <q-icon
                                name="error"
                                color="warning"
                              />
                            </template>
                            {{ siren_search.error }}
                            <template v-slot:action>
                              <q-btn
                                flat
                                color="warning"
                                label="OK"
                                @click="form_siren_search_error_show = false"
                              />
                            </template>
                          </q-banner>
                        </div>
                      </q-slide-transition>

                      <q-slide-transition>
                        <div v-if="form_siren_search_response?.matches?.length">
                          <div class="text-body2 text-bold q-mt-lg">
                            {{ siren_search.message }}
                          </div>
                          <q-list
                            color="transparent"
                            class="q-mt-md"
                          >
                            <div
                              v-for="(siren_match, index) in form_siren_search_response.matches"
                              :key="'siren_match_' + index"
                              class="q-mb-sm rounded-borders"
                            >
                              <q-item
                                clickable
                                @click="form_siren_search_select_match(siren_match)"
                              >
                                <q-item-section avatar>
                                  <q-avatar
                                    :color="siren_match.is_headquarters ? 'pastel-green' : 'pastel-blue'"
                                    text-color="black"
                                  >
                                    <q-icon
                                      :name="siren_match.is_headquarters ? 'las la-building' : 'las la-campground'"
                                      color="black"
                                    />
                                  </q-avatar>
                                </q-item-section>

                                <q-item-section>
                                  <q-item-label>{{ siren_match.company_name }} <span class="text-caption text-light q-ml-sm">({{ siren_match.company_number }})</span></q-item-label>
                                  <q-item-label
                                    caption
                                    lines="1"
                                    class="text-muted"
                                  >
                                    {{ siren_match.address ? siren_match.address + ', ' : '' }} {{ siren_match.postal_code }} {{ siren_match.city }}
                                  </q-item-label>
                                </q-item-section>

                                <q-item-section side>
                                  <q-icon name="chevron_right" />
                                </q-item-section>
                              </q-item>
                            </div>
                          </q-list>

                          <q-item class="message-box-bg q-mt-lg q-py-md rounded-borders">
                            <q-item-section avatar>
                              <q-icon
                                name="las la-exclamation-circle"
                                class="message-box-text"
                                size="md"
                              />
                            </q-item-section>
                            <q-item-section>
                              <q-item-label class="text-caption message-box-text">
                                {{ i18n.business_form_siren_match_seems_incorrect_message }}
                                <br>
                                {{ i18n.business_form_siren_retry }}
                              </q-item-label>
                            </q-item-section>
                          </q-item>
                        </div>
                      </q-slide-transition>

                      <!-- Manuel fill -->
                      <div class="fit row align-center justify-end q-mt-lg q-pr-xs">
                        <div class="col-12 text-right">
                          <q-btn
                            flat
                            icon-right="chevron_right"
                            color=""
                            :label="i18n.business_form_siren_link_skip"
                            @click="step_change_next"
                          />
                        </div>
                      </div>

                      <div class="fit row align-center justify-end q-mt-xl">
                        <div class="col-12 text-center">
                          <q-btn
                            flat
                            outline
                            icon="las la-arrow-left"
                            :label="i18n.back"
                            @click="step_change_previous"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </q-carousel-slide>

                <!-- Step 3: Business Company Details -->
                <q-carousel-slide
                  name="step_business_company"
                  class="column no-wrap flex-center max-w-lg q-mx-auto"
                >
                  <div class="fit row wrap justify-center items-start content-start q-col-gutter-md">
                    <div class="col-12 q-mb-md">
                      <span class="text-h3">{{ i18n.business_form_company_title }}</span>
                    </div>
                    <div class="col-12 q-pt-none">
                      <p>{{ i18n.business_form_company_description }}</p>
                    </div>
                  </div>

                  <q-form
                    class="fit row wrap justify-center items-start content-start q-mt-lg q-col-gutter-md"
                    @submit.prevent=""
                  >
                    <div class="col-12">
                      <span class="text-input-label">
                        {{ i18n.business_form_company_field_name }}
                      </span>
                      <q-input
                        v-model="form.company_name"
                        class="full-width q-mt-sm"
                        outlined
                        dense
                        :rules="[(val) => rule_string_len(val, 1, 40)]"
                      />
                    </div>

                    <!-- SIREN uniquement pour France -->
                    <div
                      v-if="form_settings.country == 'fr'"
                      class="col-12"
                    >
                      <span class="text-input-label">SIREN</span>
                      <q-input
                        v-model="form.siren"
                        class="full-width q-mt-sm"
                        outlined
                        dense
                        :rules="[(val) => rule_siren_format(val)]"
                      />
                    </div>

                    <div class="col-12">
                      <span class="text-input-label">
                        {{ i18n.business_form_company_field_address }}
                      </span>
                      <q-input
                        v-model="form.address_line1"
                        class="full-width q-mt-sm"
                        outlined
                        dense
                        :rules="[(val) => rule_string_len(val, 1, 60)]"
                      />
                    </div>

                    <div class="col-12 col-md-3 col-sm-6">
                      <span class="text-input-label">
                        {{ i18n.business_form_company_field_postal_code }}
                      </span>
                      <q-input
                        v-model="form.address_zip"
                        class="full-width q-mt-sm"
                        outlined
                        dense
                        :rules="[(val) => rule_string_len(val, 1, 10)]"
                      />
                    </div>

                    <div class="col-12 col-md-5 col-sm-6">
                      <span class="text-input-label">
                        {{ i18n.business_form_company_field_city }}
                      </span>
                      <q-input
                        v-model="form.address_city"
                        class="full-width q-mt-sm"
                        outlined
                        dense
                        :rules="[(val) => rule_string_len(val, 1, 40)]"
                      />
                    </div>

                    <!-- Country is readonly if it was previously selected from step 1 -->
                    <div class="col-12 col-md-4 col-sm-12">
                      <span class="text-input-label">
                        {{ i18n.business_form_company_field_country }}
                      </span>
                      <q-input
                        v-model="form.address_country"
                        class="full-width q-mt-sm"
                        outlined
                        dense
                        :readonly="form_address_country_readonly"
                        :disable="form_address_country_readonly"
                        :rules="[(val) => rule_string_len(val, 1, 40)]"
                      />
                    </div>

                    <div class="col-12">
                      <span class="text-input-label">
                        {{ i18n.business_form_company_field_currency }}
                      </span>
                      <q-select
                        v-model="form.fiat_asset_id"
                        class="full-width q-mt-sm"
                        outlined
                        hint=" "
                        dense
                        :options-dense="false"
                        :options="currencies"
                        option-value="id"
                        :option-label="option => { if (option) { return `${option.name} (${option.symbol})` } }"
                      />
                    </div>

                    <div class="fit row align-center justify-end q-mt-md">
                      <div class="col-12 text-center">
                        <q-btn
                          type="submit"
                          color="primary"
                          class="full-width"
                          no-caps
                          :loading="form_submit_state.status == 'loading'"
                          :disabled="form_submit_state.status == 'loading'"
                          :label="i18n.business_form_submit"
                          unelevated
                          @click="form_submit"
                        />
                      </div>
                      <div class="col-12 text-center q-mt-lg">
                        <q-btn
                          flat
                          outline
                          icon="las la-arrow-left"
                          :label="i18n.back"
                          @click="step_change_previous"
                        />
                      </div>
                    </div>
                  </q-form>
                </q-carousel-slide>

                <!-- Step 4: Business Submit Status -->
                <q-carousel-slide
                  name="step_business_submit"
                  class="column no-wrap flex-center max-w-lg q-mx-auto"
                >
                  <div class="row wrap justify-center items-start content-start q-col-gutter-md">
                    <div class="col-12 q-mb-md">
                      <SubmitStatus
                        :i18n="i18n"
                        :status="form_submit_state.status"
                        :error="form_submit_state.error"
                      />
                      <div class="text-center">
                        <template v-if="form_submit_state.status == 'created'" />
                        <template v-else-if="form_submit_state.status == 'loading'" />
                        <template v-else>
                          <q-btn
                            flat
                            outline
                            icon="las la-arrow-left"
                            :label="i18n.back"
                            @click="form_submit_retry"
                          />
                        </template>
                      </div>
                    </div>
                  </div>
                </q-carousel-slide>
              </q-carousel>
            </div>
          </div>
        </q-page>
      </template>
    </template>
  </Layout>
</template>
<script>
import AvatarImage from '@/shared/avatar_image.vue';
import SubmitStatus from '@/pages/wg/workspaces/submit_status.vue';
import Layout from '@/layouts/wide.vue';

export default {
  components: {
    AvatarImage,
    Layout,
    SubmitStatus,
  },
  props: {
    i18n: {
      type: Object,
      required: true,
    },
    locations_fr: {
      type: Array,
      required: true,
    },
    siren_search: {
      type: Array,
      required: false,
    },
    countries: {
      type: Object,
      required: true,
    },
    currencies: {
      type: Array,
      required: true,
    },
    redirect_to: {
      type: Array,
      required: false,
    }
  },
  data() {
    return {
      step_current_index: 0,
      form_settings: {
        type: "unselected",
        country: "other",  // 'fr', 'ch', 'lu', 'other'
      },
      form_submit_state: {
        status: '', // 'loading', 'created', 'error', ''
        error: '',
      },
      form_siren_search_response: this.siren_search,
      form_siren_search_loading: false,
      form_siren_search_error_show: false,
      form: this.$inertia.form({
        address_city: "",
        address_country: "",
        address_line1: "",
        address_zip: "",
        company_name: "",
        declaration_location_id: "",
        fiat_asset_id: "",
        non_french_resident: false,
        name: "",
        professional: false,
        siren: "", // 000000000,
      }),
    };
  },
  computed: {
    step_current: function () {
      return this.steps()[this.step_current_index];
    },
    form_address_country_readonly: function () {
      return this.form_settings.country != 'other';
    },
  },
  watch: {
  },
  remember: [
    'form',
    'form_settings',
    'step_current_index',
  ],
  methods: {
    history_back: function () {
      window.history.back();
    },
    steps: function () {
      if (this.form_settings.type == 'individual') {
        return [
          'step_individual_name',
          'step_individual_region',
          'step_individual_submit',
        ]
      } else if (this.form_settings.type == 'business' && this.form_settings.country == 'fr') {
        return [
          'step_business_country',
          'step_business_siren',
          'step_business_company',
          'step_business_submit',
        ]
      } else {
        return [
          'step_business_country',
          'step_business_company',
          'step_business_submit',
        ]
      }
    },
    step_change_next: function () {
      this.step_current_index = this.step_current_index + 1
      if (this.step_current_index < this.steps.length) {
        this.step_current_index = this.steps.length;
      }
    },
    step_change_previous: function () {
      this.step_current_index = this.step_current_index - 1;
      if (this.step_current_index < 0) {
        this.step_current_index = 0;
      }
    },
    form_type_select: function (type) {
      this.form_settings.type = type;
      this.form.professional = type == 'business';
    },
    form_country_select: function (name) {
      this.form_settings.country = name;
      if (name == 'other') {
        this.form.address_country = '';
      } else {
        this.form.address_country = this.countries[name].name;
      }
      this.form.fiat_asset_id = this.countries[name].currency;
      this.step_change_next();
    },
    form_submit_retry: function () {
      this.form_submit_state.status = '';
      this.step_change_previous();
    },
    form_submit: function () {
      this.step_change_next();
      let params = {};
      if (this.form_settings.type == 'individual') {
        params.professional = false;
        params.name = this.form.name;
        params.declaration_location_id = this.form.declaration_location_id?.id;
        params.non_french_resident = this.form.non_french_resident;
      } else if (this.form_settings.type == 'business') {
        params.professional = true;
        params.declaration_location_id = this.form.declaration_location_id?.id;
        params.address_city = this.form.address_city;
        params.address_country = this.form.address_country;
        params.address_line1 = this.form.address_line1;
        params.address_zip = this.form.address_zip;
        params.company_name = this.form.company_name;
        params.fiat_asset_id = this.form.fiat_asset_id?.id;
        params.name = this.form.name;
        params.siren = this.form.siren;
      }
      this.$inertia.post(
        './',
        params,
        {
          preserveState: true,
          preserveScroll: true,
          onStart: () => {
            this.form_submit_state.status = 'loading';
          },
          onError: (e) => {
            console.log(e);
            this.form_submit_state.status = 'error';
            this.form_submit_state.error = this.$page.props.flash.alert;
          },
          onSuccess: (data) => {
            this.form_submit_state.status = 'created';
            setTimeout(() => {
              // reset page values and redirect
              this.$inertia.get(
                data.props.redirect_to,
                {},
                {
                  preserveState: false,
                  replace: true,
                }
              );
            }, 500);
          },
        }
      );
    },
    rule_string_len: function (string, min, max) {
      if (!string) {
        return this.i18n.required;
      } else if (string.length < min) {
        return this.i18n.required_min_chars.replace("%{0}", min);
      } else if (string.length > max) {
        return this.i18n.required_max_chars.replace("%{0}", max);
      } else {
        return true;
      }
    },
    rule_siren_format: function (siren_number) {
      if (!siren_number) {
        return this.i18n.required;
      }
      const pattern = /^[0-9]{9}$/;
      return pattern.test(siren_number) || this.i18n.business_form_siren_field_siren_invalid;
    },
    phone_number_validation: function ({ valid }) {
      if (!valid) {
        this.phone_error = this.$page.props.i18n.invalid_phone_number;
      } else {
        this.phone_error = null;
      }
    },
    form_siren_search: function () {
      this.$inertia.get(
        '',
        { siren_search: this.form.siren },
        {
          preserveState: true,
          preserveScroll: true,
          only: ['siren_search'],
          onStart: () => {
            this.form_siren_search_loading = true;
            this.form_siren_search_error_show = false;
          },
          onSuccess: () => {
            this.form_siren_search_response = this.siren_search;
            this.form_siren_search_error_show = this.siren_search?.error?.length > 0;
          },
          onError: (errors) => {
            console.log(errors);
            this.$q.notify({
              message: errors,
              type: "negative",
            });
          },
          onFinish: () => {
            this.form_siren_search_loading = false;
          },
        }
      );
    },
    form_siren_search_select_match: function (details) {
      this.form.address_city = details.city;
      this.form.address_line1 = details.address;
      this.form.address_zip = details.postal_code;
      this.form.company_name = details.company_name;
      this.form.siren = details.siren;
      this.step_change_next();
    }
  },
};
</script>
<style scoped>
.wp-pro-country-flag {
  width: 48px;
  height: 36px;
  border-radius: 8px;
  transition: transform 0.1s ease-in-out;
  display: inline-block;
}

.q-card:hover .wp-pro-country-flag {
  transform: scale(1.1);
}
</style>
